import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { ApiTaRe010 } from '~/endpoints/ApiTaRe010'

// State types

// ApiTaRe010
interface LearningReport {
  learningReport: {
    memNum: string
    grade: number
    fiscalYear: number
    reportMonth: string
    message1: string
    message2: string
    subjectReportArray: {
      subjectId: string
      name: string
      subjectComments: string
      subjectPoint: number
      finishedPieceNum: number
      totalPieceNum: number
    }[]
  }
}
const getEmptyLearningReport = (): LearningReport => ({
  learningReport: {
    memNum: '',
    grade: 0,
    fiscalYear: 0,
    reportMonth: '',
    message1: '',
    message2: '',
    subjectReportArray: [],
  },
})

// State action parameter

// ApiTaRe010
interface ActionParamsLearningReport {
  memberStudyDiagnosisReportsId: number
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/AnalysisReport',
})
export default class AnalysisReport extends VuexModule {
  // States

  // ApiTaRe010
  private learningReport_ = getEmptyLearningReport()

  // Getters

  // ApiTaRe010
  get learningReports(): LearningReport {
    return this.learningReport_
  }

  // Mutations

  // ApiTaRe010
  @Mutation
  updateLearningReport(values: LearningReport) {
    this.learningReport_ = values
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateLearningReport', getEmptyLearningReport())
  }

  @Action
  async getLearningReport(param: ActionParamsLearningReport) {
    logger.trace('in: getLearningReport')
    const api = new ApiTaRe010.Api()

    // API: ApiTaRe010
    const result = await api.get<LearningReport | null>(
      {
        query: {
          memberStudyDiagnosisReportsId: param.memberStudyDiagnosisReportsId,
        },
      },
      // success
      (data, _) => {
        return {
          learningReport: data.learningReport,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateLearningReport', result)
  }
}
